(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/views/betslip/betslip-footer.js') >= 0) return;  svs.modules.push('/modules/matchen/views/betslip/betslip-footer.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.matchen=_svs.matchen||{};
_svs.matchen.templates=_svs.matchen.templates||{};
svs.matchen.templates.betslip_footer = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"numberOfRows") || (depth0 != null ? lookupProperty(depth0,"numberOfRows") : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"numberOfRows","hash":{},"data":data,"loc":{"start":{"line":4,"column":6},"end":{"line":4,"column":22}}}) : helper)))
    + " rad"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"numberOfRows") : depth0),">",1,{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":26},"end":{"line":4,"column":71}}})) != null ? stack1 : "")
    + "\n    ";
},"2":function(container,depth0,helpers,partials,data) {
    return "er";
},"4":function(container,depth0,helpers,partials,data) {
    return " 0 rader\n      &nbsp;\n";
},"6":function(container,depth0,helpers,partials,data) {
    return " betslip-is-payable";
},"8":function(container,depth0,helpers,partials,data) {
    return "";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"totalCost") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":10},"end":{"line":12,"column":65}}})) != null ? stack1 : "")
    + "\n";
},"11":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"formatCurrency")||(depth0 && lookupProperty(depth0,"formatCurrency"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"totalCost") : depth0),{"name":"formatCurrency","hash":{},"data":data,"loc":{"start":{"line":12,"column":27},"end":{"line":12,"column":55}}}))
    + " kr";
},"13":function(container,depth0,helpers,partials,data) {
    return "          - kr\n";
},"15":function(container,depth0,helpers,partials,data) {
    return "<i class=\"icon fc-white doc-icon icon-100 icon-menu-down\"></i>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"grid-row bold\">\n  <div class=\"col-xs-7 f-200 number-of-rows\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"numberOfRows") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + "  </div>\n  <div class=\"col-xs-5 f-500 slip-summary"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isValid") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":9,"column":41},"end":{"line":9,"column":90}}})) != null ? stack1 : "")
    + "\" id=\"totalAmount\">\n      <div class=\"slip-value\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isValid") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(13, data, 0),"data":data,"loc":{"start":{"line":11,"column":8},"end":{"line":15,"column":15}}})) != null ? stack1 : "")
    + "      </div>\n      <div class=\"slip-arrow\">\n        "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isValid") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":18,"column":100}}})) != null ? stack1 : "")
    + "\n      </div>\n  </div>\n</div>\n\n";
},"useData":true});
Handlebars.partials['svs-matchen-betslip_footer'] = svs.matchen.templates.betslip_footer;
})(svs, Handlebars);


 })(window);